import React from 'react';
import './Services.css';

const services = [
  { icon: '👷', title: 'Skilled Manpower', desc: 'Certified operators, welders, fitters & technical staff for precision industrial roles.' },
  { icon: '🔧', title: 'Semi-Skilled Labour', desc: 'Machine helpers, assembly line workers & trained support staff for production floors.' },
  { icon: '💪', title: 'Unskilled Labour', desc: 'Reliable unskilled workforce for general factory work, packaging & support tasks.' },
  { icon: '🧹', title: 'Housekeeping Services', desc: 'Professional cleaning teams maintaining hygiene standards across industrial facilities.' },
  { icon: '🏭', title: 'Industrial Cleaning', desc: 'Heavy-duty factory floor cleaning, machine area maintenance & waste management.' },
  { icon: '📦', title: 'Loading & Unloading', desc: 'Efficient cargo handling teams for warehouses, logistics hubs & manufacturing units.' },
  { icon: '🚛', title: 'Material Handling', desc: 'Forklift support, goods movement & inventory management workforce solutions.' },
  { icon: '🌿', title: 'Gardening Services', desc: 'Grounds upkeep, landscape maintenance & green area management for campuses.' },
  { icon: '🚗', title: 'Driver Services', desc: 'Licensed, experienced drivers for company vehicles, material transport & logistics.' },
  { icon: '🤝', title: 'Recruitment Services', desc: 'End-to-end hiring: sourcing, screening, background verification & onboarding.' },
];

const Services = () => (
  <section className="services section-gray" id="services">
    <div className="container">
      <div className="services-header">
        <span className="section-label">What We Offer</span>
        <h2 className="section-title">Our <span>Services</span></h2>
        <p className="section-desc">
          End-to-end manpower and facility management solutions crafted for industrial excellence.
        </p>
      </div>
      <div className="services-grid">
        {services.map((s) => (
          <div className="svc-card" key={s.title}>
            <div className="svc-icon">{s.icon}</div>
            <div className="svc-title">{s.title}</div>
            <div className="svc-desc">{s.desc}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
